import { HTTPError } from 'ky';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly details?: ReadonlyArray<{ path: ReadonlyArray<string | number>; message: string }>,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function parseHttpError(err: unknown): Promise<ApiError | null> {
  if (!(err instanceof HTTPError)) return null;
  try {
    const body = (await err.response.clone().json()) as {
      message?: string;
      details?: Array<{ path: Array<string | number>; message: string }>;
    };
    return new ApiError(err.response.status, body.message ?? err.message, body.details);
  } catch {
    return new ApiError(err.response.status, err.message);
  }
}

export interface FormShape {
  setError(name: string, error: { type: string; message: string }): void;
}

export async function mapApiErrorToForm(
  err: unknown,
  form: FormShape,
  opts: { rootField?: string } = {},
): Promise<void> {
  const api = await parseHttpError(err);
  if (!api) {
    form.setError('root.server', { type: 'server', message: 'Сетевая ошибка' });
    return;
  }
  if (api.status === 400 && api.details?.length) {
    for (const d of api.details) {
      const name = d.path.map(String).join('.');
      form.setError(name, { type: 'server', message: d.message });
    }
    return;
  }
  const target = opts.rootField ?? 'root.server';
  form.setError(target, { type: 'server', message: api.message });
}
